import SpinnerView from './Spinner.view';
export * from './Spinner.view';

export const Spinner = (props) => SpinnerView(props);

export default Spinner;

